import Vue from 'vue'

export default (ctx, inject) => {
    const state = Vue.observable({
        notifications: [],
    })

    function addNotification(title, message, type) {
        // Try to find the new notification in the current notifications.
        const notificationIndex = state.notifications.findIndex(
            (notification) => title === notification.title && message === notification.message
        )

        // If notification already exists, don't add it again.
        if (notificationIndex > -1) return

        // Add new notification.
        state.notifications.push({
            title,
            message,
            type,
            id: Math.random(),
        })
    }

    inject('notifications', {
        addInfo(title, message) {
            addNotification(title, message, 'DEFAULT')
        },
        addSuccess(title, message) {
            addNotification(title, message, 'SUCCESS')
        },
        addError(title, message) {
            addNotification(title, message, 'ERROR')
        },
        remove(index) {
            // If the index is out of range then don't try to remove anything
            if (index >= state.notifications.length) return
            state.notifications.splice(index, 1)
        },
        get notifications() {
            return state.notifications
        },
    })
}
